import { abbreviate } from "@/utils/misc";
import {
    AgGroupedCategoryAxisOptions,
    AgNumberAxisOptions,
} from "ag-charts-community";

export const MoneyAxis: AgNumberAxisOptions = {
    type: "number",
    position: "right",
    label: {
        formatter: (params) => "$" + abbreviate(`${params.value}`),
    },
    crosshair: {
        enabled: false,
    },
};

export const PercentageAxis: AgNumberAxisOptions = {
    type: "number",
    position: "left",
    label: {
        formatter: (params) => `${(params.value * 100).toFixed(0)}%`,
    },
    crosshair: {
        enabled: false,
    },
};

const groupedBase: AgGroupedCategoryAxisOptions = {
    type: "grouped-category",
    position: "bottom",
    line: {
        width: 1,
        stroke: "#6B7280",
    },
    gridLine: {
        enabled: false,
    },
    paddingInner: 0.3,
    label: {
        rotation: 0,
        avoidCollisions: true,
    },
};

export const GroupedCategoryAxis: {
    singleDepth: AgGroupedCategoryAxisOptions;
    doubleDepth: AgGroupedCategoryAxisOptions;
} = {
    singleDepth: {
        ...groupedBase,
        depthOptions: [
            {
                tick: { stroke: "#6B7280", width: 1 },
                label: {
                    fontSize: 11,
                    avoidCollisions: true,
                },
            },
        ],
    },
    doubleDepth: {
        ...groupedBase,
        depthOptions: [
            {
                tick: { stroke: "#6B7280", width: 1 },
                label: {
                    fontSize: 11,
                    avoidCollisions: true,
                    spacing: 8,
                    rotation: -90,
                },
            },
            {
                tick: { stroke: "#6B7280", width: 1 },
                label: {
                    fontSize: 11,
                    spacing: 12,
                    avoidCollisions: true,
                },
            },
        ],
    },
};
